export default __webpack_public_path__ + "static/media/viking-ship.265a4477.png";